

export enum Position {
    RIGHT   = 'right',
    LEFT    = 'left',
    TOP     = 'top',
    BOTTOM     = 'bottom'
}